<div class="flex items-center justify-center grow bg-center bg-no-repeat page-bg">
  <div class="card max-w-[370px] w-full">
    <!-- Verification Message - Above everything for prominence -->
    <div *ngIf="showVerificationMessage" 
         class="verification-message bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg mx-4 mt-4 mb-2 text-center animate-fade-in">
      <div class="flex items-center justify-center mb-2">
        <svg class="w-6 h-6 mr-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <strong class="font-semibold">Account Updated Successfully!</strong>
      </div>
      <p class="text-sm">{{ verificationMessage }}</p>
    </div>
    
    <form [formGroup]="signInForm" (ngSubmit)="onSubmit()" class="card-body flex flex-col gap-5 p-10">
      <div class="text-center mb-2.5">
        <div class="flex items-center justify-center font-medium">
          <a class="text-2sm link"> <img src="../../../../assets/images/logo.gif" alt="Green Dog Logo" /></a>
        </div>
      </div>
      <div class="flex flex-col gap-1">
        <label for="email" class="form-label text-gray-900">User</label>
        <input id="email" type="text" class="input" formControlName="username" placeholder="Enter UserName" />
        <div *ngIf="signInForm.controls['username'].invalid && signInForm.controls['username'].touched"
          class="text-red-600 text-xs">Valid username is required.</div>
      </div>

      <div class="flex flex-col gap-1">
        <div class="flex items-center justify-between gap-1">
          <label for="password" class="form-label text-gray-900">Password</label>
          <a class="text-2sm link shrink-0 cursor-pointer" routerLink="/auth/reset-pass"
            (click)="getpasswordcomponent($event)">Forgot Password?</a>
        </div>
        <div class="relative">
          <input id="password" [type]="showPassword ? 'text' : 'password'" class="input" formControlName="password"
            placeholder="Enter Password" minlength="4" maxlength="25"/>
          <button type="button" (click)="togglePasswordVisibility()"
            class="btn btn-icon absolute inset-y-0 right-0 pr-3 flex items-center">
            <ng-icon [name]="showPassword ? 'heroEyeSlash' : 'heroEye'" size="20" class="text-gray-500"></ng-icon>
          </button>
        </div>
        <div *ngIf="signInForm.controls['password'].invalid && signInForm.controls['password'].touched"
          class="text-red-600 text-xs">Password is required (min 4 characters).</div>
      </div>

      <!--  <label class="checkbox-group">
          <input type="checkbox" formControlName="rememberMe" class="checkbox checkbox-sm" />
          <span class="checkbox-label">Remember me</span>
        </label> -->
      <button *ngIf="!isLoading" type="submit" class="btn btn-primary flex justify-center grow"
        [disabled]="signInForm.invalid || isLoading">Sign In</button>
      <!-- show normal text when not loading -->
      <ng-container *ngIf="isLoading">
        <i class="ki-spin ki-spinner text-lg mr-2"></i>
        Signing In…
      </ng-container>
    </form>
    <div class="greendog flex justify-center items-center w-full">
      <img [src]="assetsPath + 'BBF_75.gif'" alt="Green Dog Logo" class="max-w-full h-auto" />
    </div>
    <div style="text-align: center; font-weight: bold; font-size: 11px">
      {{ version }}
    </div>
  </div>
</div>